import React from "react";
import CkEditorField from "CommonComponent/CkEditorField/CkEditorField";
import ObjectiveSnapsPanel from "../ObjectiveSnapsPanel";

const AppraisalCommentTab = ({
  formState,
  updateFormField,
  onNext,
  hasNextTab = false,
  onCancel,
  isReadOnly = false,
  appraisalProgressId = null,
  initialAttachments = [],
}) => {
  return (
    <>
      <div>
        <div className="alert-comment">
          <img
            src="/assets/images/information-alert-icon.svg"
            alt=""
            className="me-2"
          />
          <p className="mb-0 font-13 font-weight-s-bold">
            Appraiser's Comments for ratings 2 and below{" "}
            <span className="font-weight-normal">
              (Please indicate N/A if no ratings fall below 2)
            </span>{" "}
          </p>
        </div>
        <div className="my-3">
          <p className="font-13 font-weight-normal heading-color mb-2">Appraiser's Comments</p>
          <CkEditorField
            data={formState?.appraisersComments || ""}
            disabled={isReadOnly}
            readOnly={isReadOnly}
            onChange={(html) => updateFormField("appraisersComments", html)}
          />
        </div>
        <div className="alert-comment">
          <img
            src="/assets/images/information-alert-icon.svg"
            alt=""
            className="me-2"
          />
          <p className="mb-0 font-13 font-weight-s-bold">
            Employee Objectives:​{' '} <br />
            <span className="font-weight-normal">
              Establish at least 3 objectives for this person for the next quarter. List them and describe what the ideal results would be for each. Please review these goals with the employee and secure agreement on the deliverables.
            </span>{" "}
          </p>
        </div>
        <div className="my-3">
          <p className="font-13 font-weight-normal heading-color mb-2">Objective</p>
          <CkEditorField
            data={formState?.objective1 || ""}
            disabled={isReadOnly}
            readOnly={isReadOnly}
            onChange={(html) => updateFormField("objective1", html)}
          />
        </div>
        <ObjectiveSnapsPanel
          pafId={appraisalProgressId || formState?.id}
          isReadOnly={isReadOnly}
          initialAttachments={initialAttachments}
        />
        {/* <div className="my-3">
          <p className="font-13 font-weight-normal heading-color mb-2">Objective 2</p>
          <CKEditor
            editor={ClassicEditor}
            config={{
              ...CK_CONFIGS(localStorage.getItem("token")),
              readOnly: isReadOnly,
            }}
            data={formState?.objective2 || ""}
            disabled={isReadOnly}
            onChange={(_, editor) => updateFormField("objective2", editor.getData())}
          />
        </div> */}
        {/* <div className="my-3">
          <p className="font-13 font-weight-normal heading-color mb-2">Objective 3</p>
          <CKEditor
            editor={ClassicEditor}
            config={{
              ...CK_CONFIGS(localStorage.getItem("token")),
              readOnly: isReadOnly,
            }}
            data={formState?.objective3 || ""}
            disabled={isReadOnly}
            onChange={(_, editor) => updateFormField("objective3", editor.getData())}
          />
        </div> */}
        <div>
          {onCancel && (
            <button type="button" className="c-b-btn" onClick={onCancel}>
              Cancel
            </button>
          )}
          {onNext && (
            <button type="button" className="n-u-btn ms-2" onClick={onNext} disabled={!hasNextTab}>
              Next
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default AppraisalCommentTab;
